import Paper from "@mui/material/Paper";
import { popperPaperStyle } from "designSystem/styles/style-functions";
import { styled } from "@mui/material/styles";

const PopperPaper = styled(Paper)(({
	theme,
}) => (popperPaperStyle(theme)));

export default PopperPaper;
